var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"FINÁNCIALO"}},[_c('iframe',{staticClass:"financing-iframe",attrs:{"src":"https://financiamiento.macal.cl","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }